export default __webpack_public_path__ + "static/media/1.6f967a6e.jpg";